import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postGetPrivateProjectBankFileUploadSignedUrl = async (
  projectId,
  fileType
) => {
  const apiPath = `project-bank/private/project/${projectId}/signed-upload-url`;

  const data = {
    contentType: fileType,
  };

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: data,
  });

  const response = await axios(signedRequest);

  return response.data;
};
